import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // CRITICAL: skip the /me check when returning from OAuth — AuthCallback establishes the session first
    if (window.location.hash?.includes("session_id=")) return;
    // Skip the request entirely for anonymous visitors (avoids 401 console noise); flag is set on login/register
    if (!localStorage.getItem("vira_has_session")) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("vira_has_session");
        setUser(false);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("vira_has_session", "1");
    setUser(data);
    return data;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    localStorage.setItem("vira_has_session", "1");
    setUser(data);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("vira_has_session");
    setUser(false);
  };

  const setUserFromAuth = (data) => {
    localStorage.setItem("vira_has_session", "1");
    setUser(data);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, setUserFromAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
